import { createContext, useContext } from 'react';

export { InventoryProvider } from './InventoryProvider';

export const InventoryContext = createContext(null);

export const useInventoryState = () => {
    const context = useContext(InventoryContext);
    if (!context) {
        throw new Error('useInventoryState must be used within an InventoryProvider');
    }
    return context;
};
